export default __webpack_public_path__ + "static/media/plus_icon.20bbfef0.svg";